var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApertureB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.002,
    height: 16,
    viewBox: "0 0 16.002 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aperture_B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aperture_B",
    "data-name": "aperture B",
    transform: "translate(-0.197 512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M68.174-511.966a8.562,8.562,0,0,0-2.158.519,8.674,8.674,0,0,0-2.071,1.2,10.638,10.638,0,0,0-.985.941l-.059.088.1.116c.053.066.6.988,1.217,2.055s1.129,1.933,1.148,1.933.253-.394.532-.872c1.317-2.277,3.356-5.82,3.4-5.914l.053-.1-.447,0C68.655-511.994,68.33-511.978,68.174-511.966Z",
    transform: "translate(-60.741 0)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M231.792-506.916c-.022.05-.551.973-1.176,2.058s-1.148,2-1.157,2.023c-.022.053.181.056,3.973.056h3.994l-.134-.244a8.235,8.235,0,0,0-2.768-2.918,9.581,9.581,0,0,0-1.5-.732,10.844,10.844,0,0,0-1.164-.328C231.845-507,231.814-506.962,231.792-506.916Z",
    transform: "translate(-222.089 -4.844)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M1.38-395.147a12.818,12.818,0,0,0-.707,1.467,10.066,10.066,0,0,0-.4,1.607,8.287,8.287,0,0,0,.3,3.562c.053.163.075.194.119.172.028-.013,1.114-.031,2.415-.041l2.368-.016-.488-.844c-.71-1.238-3.372-5.842-3.444-5.958l-.059-.1Z",
    transform: "translate(0 -113.056)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M347.967-339.978c-.013.016-1.092.031-2.4.041l-2.371.016.422.735c.791,1.373,3.228,5.589,3.4,5.879l.169.291.1-.153a12.327,12.327,0,0,0,.7-1.454,8.147,8.147,0,0,0,.266-4.61,3.512,3.512,0,0,0-.244-.766A.081.081,0,0,0,347.967-339.978Z",
    transform: "translate(-332.274 -166.629)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M246.316-219.606c-.366.638-1.264,2.2-1.993,3.456s-1.323,2.3-1.323,2.311a11.005,11.005,0,0,0,1.533-.069,7.968,7.968,0,0,0,4.42-2.174c.206-.2.4-.4.435-.444l.059-.088-.1-.116c-.053-.066-.6-.985-1.207-2.042s-1.12-1.942-1.132-1.961A8.714,8.714,0,0,0,246.316-219.606Z",
    transform: "translate(-235.208 -282.172)",
    fill: "#21a2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M27.935-139.759a8.1,8.1,0,0,0,3.344,3.246,8.394,8.394,0,0,0,2.024.719c.128.019.131.019.163-.094a2.413,2.413,0,0,1,.2-.4c.282-.475,2.093-3.625,2.108-3.672S35.1-140,31.794-140H27.8Z",
    transform: "translate(-26.739 -360.38)",
    fill: "#21a2ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApertureB);
export default __webpack_public_path__ + "static/media/aperture_B.f880afddaf6a71df2cb7a62fc76ff6ac.svg";
export { ForwardRef as ReactComponent };